/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useRef, useEffect, useState } from "react";
import moment from "moment";
import { DateRange } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { AiOutlineCalendar } from "react-icons/ai";
import styles from "./daterangepicker.module.scss";

export const DateRangeComponent = ({
  name = "date_range",
  value = "", // "2022/02/01 - 2022/02/20",
  setFieldValue,
  ...props
}) => {
  const ref = useRef(null);

  const [is_open, setIsOpen] = useState(false);
  const [selectionRange, setSelectionRange] = useState();

  //on change values
  useEffect(() => {
    if (value && value != "") {
      let range = value.split(" - ");
      setSelectionRange([
        {
          startDate: new Date(),
          endDate: new Date(),
          key: "selection",
        },
      ]);
    } else {
      setSelectionRange([
        {
          startDate: new Date(),
          endDate: new Date(),
          key: "selection",
        },
      ]);
    }
  }, []);

  //return values
  useEffect(() => {
    if (selectionRange && selectionRange.length > 0) {
      let startDate = selectionRange[0].startDate;
      let endDate = selectionRange[0].endDate;
      const returnVal = `${moment(startDate).format("YYYY/MM/DD")} - ${moment(
        endDate
      ).format("YYYY/MM/DD")}`;
      if (setFieldValue) {
        setFieldValue(name, returnVal);
      }
    }
  }, [selectionRange]);

  //handle open datepicker
  const handleOpen = () => {
    setIsOpen(true);
  };

  //handle outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  return (
    <div className={styles.daterange_wraper} ref={ref}>
      <div className={styles.range_selector} onClick={() => handleOpen()}>
        <span>{value ?? ""}</span>
        <AiOutlineCalendar />
      </div>
      {is_open && (
        <DateRange
          onChange={(item) => setSelectionRange([item.selection])}
          moveRangeOnFirstSelection={false}
          ranges={selectionRange}
          showDateDisplay={false}
          className={styles.picker}
        />
      )}
    </div>
  );
};

export default DateRangeComponent;
